export const EditIcon: React.FC<any> = ({ className }) => {
   return (
      <svg
         className={className}
         xmlns="http://www.w3.org/2000/svg"
         width="15"
         height="15"
         viewBox="0 0 15 15"
         fill="none"
      >
         <g clip-path="url(#clip0_1987_887)">
            <path
               d="M11.0968 6.70833C11.2771 6.70833 11.4474 6.62492 11.5576 6.48258C11.6679 6.34025 11.7064 6.15475 11.6621 5.98033C11.4806 5.27042 11.1108 4.62175 10.5928 4.10375L8.55989 2.07083C7.78872 1.29967 6.76323 0.875 5.67239 0.875H3.03864C1.43098 0.875 0.122559 2.18342 0.122559 3.79167V11.9583C0.122559 13.5666 1.43098 14.875 3.03923 14.875H4.78923C5.11123 14.875 5.37256 14.6137 5.37256 14.2917C5.37256 13.9697 5.11123 13.7083 4.78923 13.7083H3.03923C2.07439 13.7083 1.28923 12.9232 1.28923 11.9583V3.79167C1.28923 2.82683 2.07439 2.04167 3.03923 2.04167H5.67298C5.76806 2.04167 5.86256 2.04633 5.95589 2.05508V4.95833C5.95589 5.92317 6.74106 6.70833 7.70589 6.70833H11.0968ZM7.12256 4.95833V2.42608C7.34364 2.55325 7.54956 2.71075 7.73506 2.89625L9.76797 4.92917C9.95114 5.11233 10.1081 5.31883 10.2364 5.54167H7.70589C7.38448 5.54167 7.12256 5.27975 7.12256 4.95833ZM13.6104 7.80442C12.9489 7.14292 11.7962 7.14292 11.1353 7.80442L7.22289 11.7168C6.78247 12.1573 6.53923 12.7435 6.53923 13.3671V14.2923C6.53923 14.6143 6.80056 14.8756 7.12256 14.8756H8.04773C8.67131 14.8756 9.25697 14.6323 9.69739 14.1919L13.6098 10.2795C13.9406 9.94875 14.1226 9.5095 14.1226 9.04167C14.1226 8.57383 13.9406 8.13458 13.6104 7.80442ZM12.785 9.45408L8.87197 13.3665C8.65206 13.587 8.35923 13.7083 8.04714 13.7083H7.70531V13.3665C7.70531 13.055 7.82664 12.7622 8.04714 12.5417L11.9601 8.62925C12.1801 8.40875 12.5645 8.40875 12.785 8.62925C12.8952 8.73892 12.9559 8.88533 12.9559 9.04167C12.9559 9.198 12.8952 9.34383 12.785 9.45408Z"
               fill="white"
            />
         </g>
         <defs>
            <clipPath id="clip0_1987_887">
               <rect
                  width="14"
                  height="14"
                  fill="white"
                  transform="translate(0.122559 0.875)"
               />
            </clipPath>
         </defs>
      </svg>
   )
}
